export default __webpack_public_path__ + "static/media/diamond_light.d822cf06.png";